<template>
  <input
    v-bind="$attrs"
    :value="value"
    :type="type"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :min="min"
    :max="max"
    :step="step"
    class="h-8 max-h-8 min-h-6 w-full rounded-sm border bg-black/20 px-2.5 text-xs text-[#e5eefc] transition-[border-color,box-shadow] duration-150 outline-none disabled:bg-[#151b21] disabled:text-slate-400 border-[#2a333d] focus:border-[#ffaa00] focus:shadow-[0_0_0_2px_rgba(255,170,0,0.18)]"
    v-on="forwardedListeners"
    @input="onInput"
  />
</template>

<script>
export default {
  name: "UiInput",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    forwardedListeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },
  methods: {
    onInput(event) {
      const nextValue = this.type === "number" && event.target.value !== ""
        ? Number(event.target.value)
        : event.target.value;
      this.$emit("input", nextValue);
    },
  },
};
</script>
